<template>
    <swiper-container ref="swiper" v-bind="$attrs" @swiperafterinit="init">
        <slot />
    </swiper-container>
</template>

<script>
import { register } from 'swiper/element/bundle'
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'

register()

export default {
    name: 'PSlider',
    data() {
        return {
            slides: [],
        }
    },
    methods: {
        init(e) {
            this.slides = e.target.swiper?.slides || []
            console.log(e.target, e.target?.swiper, this.$refs.swiper)

            // Replace navigation arrow SVGs with custom ones and calculate pagination width
            // Use setTimeout to ensure buttons are rendered
            this.$nextTick(() => {
                this.replaceNavigationArrows(e.target)
                this.calculatePaginationWidth(e.target)

                // Also try after a short delay in case buttons render asynchronously
                setTimeout(() => {
                    this.replaceNavigationArrows(e.target)
                    this.calculatePaginationWidth(e.target)
                }, 100)

                // Try again after a longer delay to ensure buttons are fully rendered
                setTimeout(() => {
                    this.replaceNavigationArrows(e.target)
                    this.calculatePaginationWidth(e.target)
                }, 500)
            })
        },
        calculatePaginationWidth(swiperContainer) {
            // Find the pagination element - this is the container with the dots
            let pagination = swiperContainer.querySelector('[part="pagination"]')

            if (!pagination && swiperContainer.shadowRoot) {
                pagination = swiperContainer.shadowRoot.querySelector('[part="pagination"]')
            }

            if (!pagination) {
                pagination = swiperContainer.querySelector('.swiper-pagination')
            }

            if (pagination) {
                // Get the actual width of just the pagination dots container
                const updateWidth = () => {
                    // Force a reflow to ensure accurate measurement
                    void pagination.offsetWidth

                    // Get the computed width using getBoundingClientRect for more accuracy
                    const rect = pagination.getBoundingClientRect()
                    const paginationWidth = rect.width


                    // Only set if we got a valid width (greater than 0)
                    if (paginationWidth > 0 && paginationWidth < 1000) { // Sanity check: should be less than 1000px
                        // Set CSS variable on the swiper container for use in CSS calc()
                        swiperContainer.style.setProperty('--pagination-width', `${paginationWidth}px`)
                    } else {
                        console.warn('Pagination width seems incorrect:', paginationWidth, 'px, retrying...')
                        // Retry after a short delay if width seems wrong
                        setTimeout(() => updateWidth(), 100)
                    }
                }

                // Calculate immediately
                updateWidth()

                // Watch for changes (e.g., when slides are added/removed)
                if (window.ResizeObserver) {
                    const resizeObserver = new ResizeObserver(() => {
                        updateWidth()
                    })
                    resizeObserver.observe(pagination)
                }
            } else {
                console.warn('Pagination element not found')
            }
        },
        replaceNavigationArrows(swiperContainer) {
            // Custom SVG for next arrow
            const nextArrowSvg = `<svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="30" y="30" width="30" height="30" rx="15" transform="rotate(180 30 30)" fill="currentColor"/>
                <path d="M13.75 20L18.75 15L13.75 10" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>`

            // Custom SVG for prev arrow
            const prevArrowSvg = `<svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0 15C0 6.71573 6.71573 0 15 0C23.2843 0 30 6.71573 30 15C30 23.2843 23.2843 30 15 30C6.71573 30 0 23.2843 0 15Z" fill="currentColor"/>
                <path d="M16.25 10L11.25 15L16.25 20" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>`

            // Find navigation buttons (they're rendered as divs with part="button-prev" and part="button-next")
            let prevButton = swiperContainer.querySelector('[part="button-prev"]')
            let nextButton = swiperContainer.querySelector('[part="button-next"]')

            if (!prevButton && swiperContainer.shadowRoot) {
                prevButton = swiperContainer.shadowRoot.querySelector('[part="button-prev"]')
                nextButton = swiperContainer.shadowRoot.querySelector('[part="button-next"]')
            }

            if (!prevButton) {
                prevButton = swiperContainer.querySelector('.swiper-button-prev')
                nextButton = swiperContainer.querySelector('.swiper-button-next')
            }

            if (prevButton) {
                // Find and replace the SVG inside prev button
                const prevSvg = prevButton.querySelector('svg')
                if (prevSvg) {
                    prevSvg.outerHTML = prevArrowSvg
                } else {
                    // If no SVG exists, insert it
                    prevButton.innerHTML = prevArrowSvg
                }
                // Ensure button is visible (in case it was hidden)
                if (prevButton.style.display === 'none') {
                    prevButton.style.display = ''
                }
            }

            if (nextButton) {
                // Find and replace the SVG inside next button
                const nextSvg = nextButton.querySelector('svg')
                if (nextSvg) {
                    nextSvg.outerHTML = nextArrowSvg
                } else {
                    // If no SVG exists, insert it
                    nextButton.innerHTML = nextArrowSvg
                }
                // Ensure button is visible (in case it was hidden)
                if (nextButton.style.display === 'none') {
                    nextButton.style.display = ''
                }
            }
        },
    },
}
</script>

